<template>
  <div class="GalleryTop container-fluid fun_container area_funmonthly">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-8 col-sm-offset-2">
          <FuncSearchGallery />

          <template v-if="locale === 'jp'">
            <LabelFunMessage fcontId="0" msgkey="17" />
          </template>
          <template v-if="locale === 'ww'">
            <LabelFunMessage fcontId="0" msgkey="26" />
          </template>

          <h2 class="garally_title">
            <span class="glyphicon glyphicon-tag"></span>
            <LabelFunMessage fcontId="0" msgkey="1" />
          </h2>

          <template v-if="articlesStatus">
            <a v-on:click="clickLink()">
              <div class="thumbnail new-thumbnail">
                <img v-bind:src="firstArticleImagePath"  alt="..." class="lazyload fun_1st_img"/>
                <div class="caption">
                  <h3 class="thum_title items">
                    <LabelFunMessage :fcontId="firstArticleId.toString()" msgkey="1" />
                  </h3>
                  <p class="des_funcontents">
                    <LabelFunMessage :fcontId="firstArticleId.toString()" msgkey="2" />
                  </p>
                </div>
                <img v-if="isNew" :src="app_root + '/assets/common/img/new_label.svg'" class="new_label" />
              </div>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import FuncSearchGallery from "./FuncSearchGallery";

export default {
  name: "GalleryTop",
  components: {
    LabelFunMessage,
    FuncSearchGallery
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(["locale", "setupnavi", "languageChangeCount", "lg2"]),
    ...mapState('articles', ['articles', 'articlesStatus', 'firstPriority']),
    ...mapState("messages", ["messages"]),

    firstArticleId: function() {
      return this.articles.find(article => article.priority === this.firstPriority).id;
    },

    firstArticleImagePath: function() {
      const id = this.articles.find(article => article.priority === this.firstPriority).id;
      return this.app_root + "/assets/article" + id + "/images/i7.jpg";
    },

    articleIsReady: function() {
      return 0 !== Object.keys(this.articles).length;
    },

    isNew: function() {
      return this.articles.find(article => article.priority === this.firstPriority).isNew
    }

  },
  methods: {
    clickLink: function () {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "top_articles",
        "custom_parameter2": this.firstArticleId,
        "custom_parameter3": "1"
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/' + this.firstArticleId,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>